module.exports = __webpack_public_path__ + "img/puzzlePiece_b.4dbf9326.svg";